<ng-container *ngIf="permConfig.isAddAllowed">
    <div class="container-fluid">
        <app-page-title title="Add Entry"></app-page-title>
        <form [formGroup]="addressbookForm" (ngSubmit)="addAddressBook();" (keydown.enter)="useEnterKey ? $event.preventDefault() : addAddressBook()">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="name" class="form-label">Name <span
                                                class="mandatory">*</span></label>
                                        <input type="text" class="form-control form-control-sm" id="name"
                                            formControlName="txtName" maxlength="50"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || addressbookForm.get('txtName').touched) && addressbookForm.get('txtName').errors}" >
                                        <div *ngIf="(isFormSubmitted || addressbookForm.get('txtName').touched) && addressbookForm.get('txtName').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="addressbookForm.get('txtName').errors.required">Name is
                                                required</span>
                                            <span *ngIf="addressbookForm.get('txtName').errors.maxlength">Must be of 50
                                                characters.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="contactperson" class="form-label">Contact Person </label>
                                        <input type="text" class="form-control form-control-sm" id="contactperson"
                                            formControlName="txtContactPerson" maxlength="50" >
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="emailid" class="form-label">Email ID </label>
                                        <input type="email" class="form-control form-control-sm" id="emailid"
                                            placeholder="Ex. abc@domain.com" formControlName="txtEmailId" maxlength="50"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || addressbookForm.get('txtEmailId').touched) && addressbookForm.get('txtEmailId').errors}" >
                                        <div *ngIf="(isFormSubmitted || addressbookForm.get('txtEmailId').touched) && addressbookForm.get('txtEmailId').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="addressbookForm.get('txtEmailId').errors.pattern">Invalid email
                                                format</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="gst" class="form-label">GST No.</label>
                                        <input type="text" maxlength="15" class="form-control form-control-sm" id="gst"
                                            formControlName="txtGST"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || addressbookForm.get('txtGST').touched) && addressbookForm.get('txtGST').errors}" >
                                        <div *ngIf="(isFormSubmitted || addressbookForm.get('txtGST').touched) && addressbookForm.get('txtGST').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="addressbookForm.get('txtGST').errors.pattern">Invalid GST
                                                Format.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="iec" class="form-label">IEC No</label>
                                        <input type="text" maxlength="20" class="form-control form-control-sm" id="iec"
                                            formControlName="txtIEC"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || addressbookForm.get('txtIEC').touched) && addressbookForm.get('txtIEC').errors}" >
                                        <div *ngIf="(isFormSubmitted || addressbookForm.get('txtIEC').touched) && addressbookForm.get('txtIEC').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="addressbookForm.get('txtIEC').errors.maxlength">Max of 20
                                                characters.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="industryType" class="form-label">Industry Type</label>
                                        <ng-select id="industryType" placeholder="Select"
                                            formControlName="ddlIndustryType" [items]="industryTypeList"
                                            [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            bindLabel="name" [bindValue]="'id'"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || addressbookForm.get('ddlIndustryType').touched) && addressbookForm.get('ddlIndustryType').errors}" >
                                        </ng-select>

                                        <div *ngIf="(isFormSubmitted || addressbookForm.get('ddlIndustryType').touched) && addressbookForm.get('ddlIndustryType').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="addressbookForm.get('ddlIndustryType').errors.required">Industry
                                                Type is required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-3">
                                    <div class="">
                                        <label for="status" class="form-label">Status</label>
                                        <div class="form-check form-switch form-switch-md">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="status" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> Location Details </div>
                        <div class="card-body">
                            <app-location formGroupName="locationdetails"
                                [formSubmitted]="isFormSubmitted"></app-location>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 d-flex flex-grow-1">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> Bank Details </div>
                        <div class="card-body">
                            <app-bank-details formGroupName="bankDetails"></app-bank-details>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-flex flex-grow-1" formGroupName="lutdetails">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> LUT Details </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="lutbondno" class="form-label">Bond No.</label>
                                        <input type="text" class="form-control form-control-sm" maxlength="30"
                                            formControlName="txtLutBondNo"
                                            [ngClass]="{ 'is-invalid':(isFormSubmitted ||addressbookForm.get('lutdetails.txtLutBondNo').touched) && addressbookForm.get('lutdetails.txtLutBondNo').errors}" />
                                        <div *ngIf="(isFormSubmitted ||addressbookForm.get('lutdetails.txtLutBondNo').touched) &&addressbookForm.get('lutdetails.txtLutBondNo').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="addressbookForm.get('lutdetails.txtLutBondNo').errors.maxlength">Bond No max length is 30 characters.</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="lutissuedate" class="form-label">Issue Date.</label>
                                        <input type="date" class="form-control form-control-sm" maxlength="30"
                                            formControlName="lutIssueDate" />
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="lutilldate" class="form-label">Till Date.</label>
                                        <input type="date" class="form-control form-control-sm" maxlength="30"
                                            formControlName="lutTillDate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="button-items">
                        <button type="submit" class="btn btn-primary w-sm" >Add</button>
                        <a routerLink="/setup/general/addressbook"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>

<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>